export default {
  title: 'Konto gesperrt',
  description:
    'Dein Konto wurde vorübergehend gesperrt. Dies kann auf einen Verstoß gegen unsere Nutzungsbedingungen oder ungewöhnliche Aktivitäten zurückzuführen sein. Bitte kontaktiere unser Support-Team, um dies zu klären.',
  contactLabel: 'Unser Support-Team erreichen',
  emailSubject: 'Kontosperrung — Hilfeanfrage',
  emailHint: 'Wir antworten in der Regel innerhalb von 24 Stunden',
  note: 'Bitte gib deine registrierte E-Mail-Adresse an, wenn du den Support kontaktierst.',
  logout: 'Abmelden',
};